export default {
  typography: {
    fontFamily: 'Arial',
    fontSize: { value: 16, unit: 'px' },
    fontWeight: 600,
    fontTransform: 'uppercase',
    fontSpacing: { value: 0, unit: 'px' }
  }
}
